import type { TableVariant } from "../utils-v2";
import type { SortDirection } from "../utils-v2";

export type { SortDirection };

export interface SortOption {
  label: string;
  sortColumn: string;
  direction: SortDirection;
}

export function getMobileSortOptions(tableVariant: TableVariant): SortOption[] {
  const propsOptions: SortOption[] = [
    {
      label: "% To Hit",
      sortColumn: "consensus_implied_probability",
      direction: "desc",
    },
    {
      label: "Start Time",
      sortColumn: "game_start_timestamp",
      direction: "asc",
    },
  ];

  if (tableVariant === "props") {
    return propsOptions;
  }

  return [
    {
      label: "EV%",
      sortColumn: "ev_percentage",
      direction: "desc",
    },
    ...propsOptions,
  ];
}
